import { render, staticRenderFns } from "./boundaryWarningSettings.vue?vue&type=template&id=25d38fa0&scoped=true"
import script from "./boundaryWarningSettings.vue?vue&type=script&lang=js"
export * from "./boundaryWarningSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d38fa0",
  null
  
)

export default component.exports